// extracted by mini-css-extract-plugin
module.exports = {"item":"breadcrumbItem_item__37nGF","link":"breadcrumbItem_link__3TQJJ"};